import type { IAppState } from 'shared/common/state';
import type { ISpecialPromoBuilderOffersSchema } from 'shared/repositories/commercial-search-offers/entities/special_promo_builder_offers/SpecialPromoBuilderOffersSchema';

import { resultsSelector } from '../commonSelectors';

export const selectSpecialPromoBuilderOffers = (state: IAppState): ISpecialPromoBuilderOffersSchema | undefined =>
  resultsSelector(state).specialPromoBuilderOffers;
